import { render, staticRenderFns } from "./AutomotiveProduct.vue?vue&type=template&id=62059339&"
import script from "./AutomotiveProduct.vue?vue&type=script&lang=js&"
export * from "./AutomotiveProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports